module.exports = __webpack_public_path__ + "static/img/dup_2x.d4ec236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dup_2x.png
// module id = +yll
// module chunks = 1